import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_marketplace_value = _resolveComponent("marketplace-value");
  const _component_marketplace_filter_body = _resolveComponent("marketplace-filter-body");
  const _component_filter_item = _resolveComponent("filter-item");
  return _openBlock(), _createBlock(_component_filter_item, {
    id: "marketplaces",
    ref: "marketplaceFilterItem",
    icon: "MarketplaceIcon",
    title: "All Marketplaces",
    selectedTitle: $options.getMarketplacesSelectedTitle,
    selectedCount: $props.marketplaces?.filterState?.selectedCount,
    no_reset: $props.no_reset,
    onClearAll: $options.onClear,
    onApply: $options.onApply,
    onHidden: $options.onHidden
  }, _createSlots({
    body: _withCtx(() => [_createVNode(_component_marketplace_filter_body, {
      title: "Marketplace",
      selected: $props.marketplaces?.filterState?.selected,
      isModified: $props.marketplaces.isModified,
      pendingChanges: $props.marketplaces.pendingChanges,
      isSearching: $props.marketplaces.isSearching,
      keyword: $props.marketplaces.keyword,
      list: $props.marketplaces.displayList,
      no_reset: $props.no_reset,
      onClear: $options.onClear,
      onDiscard: $options.onDiscard,
      onRestoreSearch: $options.onRestoreSearch,
      onSelect: $options.onSelect,
      onSelectOnly: $options.onSelectOnly,
      onDeselect: $options.onDeSelect,
      onApply: $options.onApply,
      onSearch: $options.onSearch,
      onHidden: $options.onHidden,
      onCloseDropdown: $options.onClose
    }, null, 8, ["selected", "isModified", "pendingChanges", "isSearching", "keyword", "list", "no_reset", "onClear", "onDiscard", "onRestoreSearch", "onSelect", "onSelectOnly", "onDeselect", "onApply", "onSearch", "onHidden", "onCloseDropdown"])]),
    _: 2
  }, [$options.getMarketplace ? {
    name: "title",
    fn: _withCtx(() => [_createVNode(_component_marketplace_value, {
      gap: 8,
      marketplace: $options.getSelectedMarketplaces,
      flag: $options.getMarketplace.icon
    }, null, 8, ["marketplace", "flag"])]),
    key: "0"
  } : undefined]), 1032, ["selectedTitle", "selectedCount", "no_reset", "onClearAll", "onApply", "onHidden"]);
}